export const crowdsaleContractAddress = '';
export const cratTokenAddress = '0xc6D7062eD5B8Bf1532CBC101E4daa0cC0B06F2a2';
export const cratDecimals = 8;

export const chainId = '0x38';

export const stakingFactoryAddress = '0xC96a7dad0c6b775e702F5Cc744E43BC01d18c5C5';
